import {
  CourseDetailsDTO,
  CourseEnrollmentRequestDTO,
  CourseInstanceDetailResponseDTO,
  CourseSendReminderRequestDTO,
  CourseUnenrollmentRequestDTO,
  EnrolledStudentDTO,
} from '../models/CourseDTO';
import { CourseInstanceUIModel } from '../models/CourseInstanceUIModel';
import { CourseEnrolledStudentUIModel } from '../models/CourseEnrolledStudentUIModel';
import { CourseGalleryItemDTO } from '../../learning-plan/models/LearningPlanDTO';
import { CourseGalleryService } from '../../learning-plan/services/course-gallery.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export function toCourseEnrollmentRequestDTO(
  students: Array<{ id: string }>,
): CourseEnrollmentRequestDTO {
  const courseEnrollmentRequestDTO = new CourseEnrollmentRequestDTO();
  courseEnrollmentRequestDTO.students = students;
  return courseEnrollmentRequestDTO;
}

function toEnrolledStudentUIModel(
  students: EnrolledStudentDTO[],
): CourseEnrolledStudentUIModel[] {
  return students.map((student) => {
    const username = `${student.firstName} ${student.lastName}`;
    const { email, id, courseProgress, syncStatus } = student;
    return {
      id,
      username,
      syncStatus,
      email,
      courseProgress,
    };
  });
}

export function toCourseInstanceUIModel(
  courseInstanceDetailResponse: CourseInstanceDetailResponseDTO,
): CourseInstanceUIModel {
  return {
    id: courseInstanceDetailResponse.courseInstance.id,
    course: { name: courseInstanceDetailResponse.courseInstance.course.name },
    students: toEnrolledStudentUIModel(
      courseInstanceDetailResponse.courseInstance.students,
    ),
  };
}

export function toCourseUnenrollmentRequestDTO(
  students: CourseEnrolledStudentUIModel[],
): CourseUnenrollmentRequestDTO {
  const courseUnenrollmentRequestDTO = new CourseEnrollmentRequestDTO();
  courseUnenrollmentRequestDTO.students = students.map((student) => ({
    id: student.id,
  }));
  return courseUnenrollmentRequestDTO;
}

export function toSendReminderRequestDTO(
  students: CourseEnrolledStudentUIModel[],
  courseInstanceId: string,
): CourseSendReminderRequestDTO {
  const reminderRequestDTO = new CourseSendReminderRequestDTO();
  reminderRequestDTO.students = students.map((student) => ({
    id: student.id,
    courseInstanceId: courseInstanceId,
  }));
  return reminderRequestDTO;
}

export function toCourseGalleryItemDTO(
  course: CourseDetailsDTO,
  courseGalleryService: CourseGalleryService,
): Observable<CourseGalleryItemDTO> {
  return courseGalleryService.getCourses(course.topicAreaId).pipe(
    map((courses) => {
      const matchingCourse = courses.find((c) => c.id === course.id);
      if (!matchingCourse) {
        throw new Error(`Course with ID ${course.id} not found in gallery`);
      }
      return matchingCourse;
    }),
  );
}
